import "flickity/dist/flickity.min.css";

let defaultOps = {
  accessibility: false,
  adaptiveHeight: false,
  pauseAutoPlayOnHover: true,
  autoPlay: 3000,
  cellAlign: "center",
  cellSelector: ".image-slider__slide",
  contain: false,
  draggable: true,
  dragThreshold: 0,
  groupCells: false,
  initialIndex: 0,
  prevNextButtons: true,
  pageDots: false,
  resize: true,
  setGallerySize: true,
  wrapAround: true
};

const ImageSlider = () => {
  let element = document.querySelector(".image-slider");
  if (typeof element != "undefined" && element != null) {
    let flky = new Flickity(".image-slider", { ...defaultOps });
    flky;
  }

};

export default ImageSlider;


// WEBPACK FOOTER //
// ./src/js/app/components/ImageSlider.js